var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"list-container"},[_c('h5',[_vm._v(_vm._s(_vm.heading))]),_vm._v(" "),(_vm.category.length > 0)?_c('ul',{staticClass:"attribute-list"},_vm._l((_vm.category),function(attribute){return _c('li',{staticClass:"list-item"},[_vm._v(_vm._s(attribute))])}),0):_c('p',[_vm._v("N/A")])])
}
var staticRenderFns = []

export { render, staticRenderFns }